import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { MonitorPlay, GraduationCap, MessageCircle } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const HIDE = ["/admin", "/teacher", "/principal", "/student", "/verify", "/simran-live"];
export const useShowBar = () => {
  const { pathname } = useLocation();
  return !HIDE.some((p) => pathname.startsWith(p));
};

// Phone-only sticky actions: free class, enroll, WhatsApp share. Hides while typing so it never covers a form field.
export const MobileActionBar = () => {
  const { L } = useLang();
  const show = useShowBar();
  const [typing, setTyping] = useState(false);
  useEffect(() => {
    const field = (el) => /^(INPUT|TEXTAREA|SELECT)$/.test(el?.tagName || "");
    let t;
    const on = (e) => { clearTimeout(t); setTyping(field(e.target)); };
    // Come back a moment after the field blurs, so a tap on a button next to it (e.g. Send) lands before the bar returns.
    const off = () => { clearTimeout(t); t = setTimeout(() => setTyping(field(document.activeElement)), 450); };
    document.addEventListener("focusin", on);
    document.addEventListener("focusout", off);
    return () => { clearTimeout(t); document.removeEventListener("focusin", on); document.removeEventListener("focusout", off); };
  }, []);
  if (!show || typing) return null;
  const text = L(`Free robotics, drone & AI classes with Zoya Ma'am on RoboSpark: ${window.location.origin}/virtual-classroom`,
    `RoboSpark पर ज़ोया मैम के साथ मुफ़्त रोबोटिक्स, ड्रोन और AI क्लास: ${window.location.origin}/virtual-classroom`);
  const item = "flex-1 flex flex-col items-center justify-center gap-0.5 h-14 rounded-2xl text-[11px] font-bold active:scale-95 transition-transform";
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white/90 backdrop-blur-xl border-t border-slate-200 shadow-[0_-8px_30px_-12px_rgba(10,25,47,0.25)] px-3 pt-2 pb-[calc(0.5rem+env(safe-area-inset-bottom))]" data-testid="mobile-action-bar">
      <div className="flex items-center gap-2">
        <Link to="/virtual-classroom" className={`${item} text-[#0A192F] hover:bg-[#E8F0FE]`} data-testid="mobile-bar-class">
          <MonitorPlay className="w-5 h-5 text-[#007A8A]" />{L("Free Class", "मुफ़्त क्लास")}
        </Link>
        <Link to="/enroll" className={`${item} flex-[1.4] bg-[#FF3B3B] text-white text-sm shadow-[0_10px_24px_-10px_rgba(255,59,59,0.8)]`} data-testid="mobile-bar-enroll">
          <GraduationCap className="w-5 h-5" />{L("Enroll Now", "दाखिला लें")}
        </Link>
        <a href={`https://wa.me/?text=${encodeURIComponent(text)}`} target="_blank" rel="noreferrer" className={`${item} text-[#0A192F] hover:bg-[#E8F0FE]`} data-testid="mobile-bar-whatsapp">
          <MessageCircle className="w-5 h-5 text-[#25D366]" />WhatsApp
        </a>
      </div>
    </nav>
  );
};
